import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Address } from 'src/app/services/address/address.service';

@Component({
  selector: 'app-address-card',
  templateUrl: './address-card.component.html',
  styleUrls: ['./address-card.component.css'],
})
export class AddressCardComponent {
  @Input() address!: Address;
  @Output() editClicked = new EventEmitter<string>();
}
